export default "__VITE_ASSET__0e155aa5__"